import swal from "sweetalert"

import submitSearchifyFunctions from "search-new/searchify/submit-searchify-functions"
import { hideChangedInListManuallyFilter } from "shared/search/action-creators"
import { processSubmitSearchify } from "shared/search/searchify/action-creators"
import { popSearchify } from "app/static/frontend/search-new/searchify/searchify-action-creators"
import searchifyActionTypes from "shared/search/searchify/action-types"

export function submitSearchify(uniqueFlvId) {
    return async (dispatch, getState) => {
        const { submitSearchifyFunc, callBack } = getState()
            .search.getIn(["filterableListViews", uniqueFlvId, "searchify"])
            .toJS()

        dispatch(hideChangedInListManuallyFilter())
        const mySubmitFunction = submitSearchifyFunctions[submitSearchifyFunc]

        const validationObject = await dispatch(processSubmitSearchify(uniqueFlvId, mySubmitFunction, callBack))

        if (validationObject.validated) {
            dispatch(popSearchify())
            return true
        } else if (!validationObject.submitAsyncCancelled) {
            swal(validationObject.headerMessage, validationObject.alertMessage, "warning")
            return false
        }
        return false
    }
}

export function cancelSearchify() {
    return (dispatch) => {
        dispatch(hideChangedInListManuallyFilter())
        dispatch({ type: searchifyActionTypes.SEARCHIFY_CLEAR })
        dispatch(popSearchify())
    }
}
